import authService from '../components/api-authorization/AuthorizeService';

export const authorizedFetch = async (url, options = {}) => {
    const token = await authService.getAccessToken();

    const defaultHeaders = {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
    };

    const response = await fetch(url, {
        ...options,
        headers: {
            ...defaultHeaders,
            ...(options.headers || {})
        }
    });

    return response;
};

export default authorizedFetch;
